// Action types for Ask AI chat tracking
export const TRACK_ASK_AI_CHAT = 'chat/trackAskAI';

export type AskAIChatType = 'video' | 'multifile' | 'singlefile' | 'search';

export interface TrackAskAIChatPayload {
  chatType: AskAIChatType;
  question: string;
  fileCount: number;
  isVideoMode?: boolean;
  ocrEnabled?: boolean;
  sessionId: string | null;
  isNewSession: boolean;
}

/**
 * Action creator for tracking Ask AI chat queries
 * @param payload - The tracking payload
 * @returns Redux action
 */
export const trackAskAIChat = (payload: TrackAskAIChatPayload) => ({
  type: TRACK_ASK_AI_CHAT,
  payload,
});
